import React, { useCallback, useEffect, useMemo, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { columnsNews } from "../../Global Functions/columnsAntd";
import { getNewsList } from "../../Redux/Actions/newsAction";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const DEBOUNCE_DELAY = 500;

const ListNews = () => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const { news, loading } = useSelector(
    (state) => ({
      news: state.news?.news,
      loading: state.news?.loading,
    }),
    shallowEqual
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
      setPagination((p) => ({ ...p, current: 1 }));
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const requestPayload = useMemo(() => {
    const payload = {
      page: pagination.current,
      limit: pagination.pageSize,
      filter: debouncedSearch,
    };

    if (dateRange.start) {
      payload.start_date = dateRange.start.format("YYYY-MM-DD");
    }

    if (dateRange.end) {
      payload.end_date = dateRange.end.format("YYYY-MM-DD");
    }

    return payload;
  }, [
    pagination.current,
    pagination.pageSize,
    debouncedSearch,
    dateRange,
  ]);

  useEffect(() => {
    dispatch(getNewsList(requestPayload));
  }, [dispatch, requestPayload]);

  useEffect(() => {
    if (news?.total !== pagination.total) {
      setPagination((p) => ({
        ...p,
        total: news?.total || 0,
      }));
    }
  }, [news?.total, pagination.total]);

  const handleTableChange = useCallback((pager) => {
    setPagination((p) => ({
      ...p,
      current: pager.current,
      pageSize: pager.pageSize,
    }));
  }, []);

  const handleDateRangeApply = useCallback((start, end) => {
    setDateRange({ start, end });
    setIsDatePopupVisible(false);
    setPagination((p) => ({ ...p, current: 1 }));
  }, []);

  const tableData = useMemo(
    () => (Array.isArray(news?.data) ? news.data : []),
    [news?.data]
  );

  return (
    <>
      <TableComponent
        columns={columnsNews}
        dataSource={tableData}
        h3heading="News and Articles"
        setState={setSearchQuery}
        onChange={handleTableChange}
        pagination={pagination}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        buttonhead2="Add News"
        navigateTo2="/news_and_articles/add"
        loading={loading}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListNews;
